import React, { useMemo } from 'react';
import styled from 'styled-components';
import { Link, useLocation } from 'react-router-dom';

import COLORS from '@mlb/react-patterns/style/universal.color';
import FONTS from '@mlb/react-patterns/style/fonts.ts';
import IconWrapper from '@mlb/react-patterns/components/Icon/icon.tsx';

import { mainCq } from 'bdvp-common/src/styles/helpers/main-cq';
import { useDictionary } from 'bdvp-common/src/hooks/config';
import { QUERY_PARAMS, SEARCH_ROUTE } from 'bdvp-common/src/utils/constants';

import { Tracking } from 'bdvp-tracking';

const A = styled(Link)`
    display: inline-block;
    margin: 12px 0 13px 8px;
    color: ${COLORS.mlbGrey3};
    font-family: ${FONTS.primaryFont};
    font-size: 13px;
    font-weight: 600;

    ${mainCq.lg`
        margin: 0 0 11px;
    `}
    body & {
        color: ${COLORS.mlbGrey3};
        &:hover {
            color: ${COLORS.mlbGrey3};
        }
    }
`;

const Icon = styled(IconWrapper)`
    margin: 0 5px 2px 0;
    vertical-align: middle;
`;

const ResultsLink = () => {

    const location = useLocation();
    const dictionary = useDictionary();

    const searchLink = useMemo(() => {

        const searchParams = new URLSearchParams(location.search);
        const queryType = searchParams.get(QUERY_PARAMS.queryType)
            ? `&${QUERY_PARAMS.queryType}=${searchParams.get(QUERY_PARAMS.queryType)}` : '';

        return `${SEARCH_ROUTE}?q=${searchParams.get(QUERY_PARAMS.query) + queryType || ''}`;

    }, [location.search]);

    return (
        <A to={searchLink} onClick={Tracking.trackResultsLinkClick}>
            <Icon name={'carousel-arrow-left'} width={12} size={'md'}/>
            {dictionary.back_to_results || 'Back to Results'}
        </A>
    );

};

export default ResultsLink;
